import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Target } from "lucide-react";

export default function PredictTarget() {
  const [round, setRound] = useState("r1");
  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("/predict/target", { params: { round, limit: 20 } })
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [round]);

  return (
    <>
      <PageHeader title="Predict Target" subtitle="Round-specific target picks" />
      <div className="max-w-xl mx-auto w-full px-4 pb-10 space-y-4">
        <Card className="p-2 border-slate-200 flex">
          <Button
            variant={round === "r1" ? "default" : "ghost"}
            className="flex-1 rounded-lg"
            onClick={() => setRound("r1")}
            data-testid="pt-r1"
          >
            First Round
          </Button>
          <Button
            variant={round === "r2" ? "default" : "ghost"}
            className="flex-1 rounded-lg"
            onClick={() => setRound("r2")}
            data-testid="pt-r2"
          >
            Second Round
          </Button>
        </Card>

        <Card className="p-5 border-slate-200">
          <div className="flex items-center gap-2 mb-3">
            <Target className="h-4 w-4 text-teal-700" />
            <h3 className="font-heading font-bold">Suggested Targets</h3>
          </div>
          <div className="grid grid-cols-3 gap-2">
            {(data?.suggestions || []).map((n, i) => (
              <div
                key={n + i}
                className="rounded-2xl bg-gradient-to-br from-teal-600 to-emerald-700 text-white p-4 text-center shadow-md"
              >
                <div className="font-numbers font-black text-3xl">{n}</div>
              </div>
            ))}
            {(!data?.suggestions || data.suggestions.length === 0) && (
              <div className="col-span-3 text-slate-500 text-sm py-4 text-center">
                Publish more results to unlock predictions.
              </div>
            )}
          </div>
        </Card>

        <Card className="p-5 border-slate-200">
          <div className="grid grid-cols-2 gap-4 text-center">
            <div>
              <div className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-1">Top House</div>
              <div className="font-numbers font-black text-2xl text-slate-900">
                {(data?.top_house || []).join(" · ") || "—"}
              </div>
            </div>
            <div>
              <div className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mb-1">Top Ending</div>
              <div className="font-numbers font-black text-2xl text-slate-900">
                {(data?.top_ending || []).join(" · ") || "—"}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
}
